import React, {Component} from 'react'
import CompanyForm from "./companyForm.component.jsx"
import CustomerForm from "./customerForm.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class CustomerNew extends Component {

    constructor(props, context) {
        super(props, context);

        let contactId = ''
        let cancelRedirectPath = ''
        let saveRedirectPath = ''
        let companyIdentifier = ''
        let contactType = 'persons'
        if (this.props.match && this.props.match.params.contactId) {
            contactId = this.props.match.params.contactId
        }

        if (this.props.location && this.props.location.state && this.props.location.state.cancelRedirectPath) {
            cancelRedirectPath = this.props.location.state.cancelRedirectPath
        }

        if (this.props.location && this.props.location.state && this.props.location.state.saveRedirectPath) {
            saveRedirectPath = this.props.location.state.saveRedirectPath
        }

        if (this.props.location && this.props.location.state && this.props.location.state.contactType) {
            contactType = this.props.location.state.contactType
        }
        if (this.props.location && this.props.location.state && this.props.location.state.companyIdentifier) {
            companyIdentifier = this.props.location.state.companyIdentifier
        }

        this.state = {
            contactId: contactId,
            cancelRedirectPath: cancelRedirectPath,
            saveRedirectPath: saveRedirectPath,
            contactType: contactType,
            companyIdentifier: companyIdentifier,
        }

        this.contactForm = this.contactForm.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('contact')
    }

    contactForm() {
        if(this.state.contactType == 'organizations') {
            return <CompanyForm contactId={this.state.contactId} cancelRedirectPath={this.state.cancelRedirectPath} saveRedirectPath={this.state.saveRedirectPath}/>
        } else {
            return <CustomerForm companyIdentifier={this.state.companyIdentifier} contactId={this.state.contactId} cancelRedirectPath={this.state.cancelRedirectPath} saveRedirectPath={this.state.saveRedirectPath}/>
        }
    }

    render() {
        return (
            <div>
                {this.contactForm()}
            </div>
        );
    }
}

export default CustomerNew


// WEBPACK FOOTER //
// ./src/customer/newCustomer.component.jsx